import { useIntl } from 'react-intl';

import { RecordingAsset } from '@kaltura-ott/tvpil-shared';

import { isStandaloneRecordingAsset } from '../../utils';

const translationId = 'Rail.RailCard';

export function useEpisodesCounterBadge(recording: RecordingAsset) {
  const intl = useIntl();

  if (isStandaloneRecordingAsset(recording) || !recording.totalEpisodesCount) {
    return undefined;
  }

  return intl.formatMessage(
    {
      id: `${translationId}.recordedEpisodes.${intl.formatPlural(recording.totalEpisodesCount)}`,
      defaultMessage: '{episodesCount, plural, one {# Episode Recorded} other {# Episodes Recorded}}',
    },
    { episodesCount: recording.totalEpisodesCount },
  );
}
